import Vue from "vue";
import Router from "vue-router";
import statistics from "@/utils/statistics"; // 统计
import Routes from "./routes";

Vue.use(Router);

// 初始化统计
statistics.init();

const base = process.env.BASE_URL;

// 实例化路由
const router = new Router({
  base,
  mode: "history", // require service support (另外默认支持hash)
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  routes: Routes
});

// 路由声明周期
router.beforeEach(async (to, from, next) => {
  next();
});

router.afterEach(route => {
  // 设置路由title
  const { title = "", custom = false } = route.meta || {};
  if (!custom && title) {
    document.title = title;
  }

  // 拿到正确的路径，多以添加延迟
  setTimeout(() => {
    statistics.trackPageView(base.replace(/\/$/) + route.fullPath); // 百度统计
  }, 300);
});

export default router;
